import React from 'react'
import { Image } from '@shared/components/image'
import { useMedia } from 'use-media'

import { data } from './data'
import { QR } from './QR'

import styles from './styles.module.scss'

export const View = () => {
	const isTablet = useMedia({ minWidth: '1024px' })
	const isDesktop = useMedia({ minWidth: '1440px' })

	return (
		<div className={styles.sublayer}>
			<header className={styles.header}>
				<div className={styles.headerContainer}>
					<Image name={isDesktop ? 'cc-logo-big' : 'cc-logo-small'} />
				</div>
			</header>
			<main className={styles.main}>
				<h1 className={styles.heading}>{data.heading}</h1>

				<div className={styles.qr}>
					<div>
						<h3 className={styles.qrTitle}>
							Сделайте перевод по реквизитам <br />
							КПК «Фонд ипотечного кредтитования»
						</h3>
						<p className={styles.qrDescription}>{data.qr.description}</p>
						<p className={styles.qrSum}>{data.qr.sum}</p>
					</div>
					<div className={styles.qrBox}>
						<div className={styles.qrInner}>
							<QR size={isTablet ? 201 : 217} />
						</div>
					</div>
				</div>

				<div className={styles.requisites}>
					<h3 className={styles.requisitesTitle}>{data.requisites.title}</h3>

					<div>
						{data.requisites.firstContent.map(({ description, value }) => {
							return (
								<div className={styles.requisitesWrapper} key={description}>
									<p className={styles.requisitesDescription}>{description}</p>
									<p className={styles.requisitesValue}>{value}</p>
								</div>
							)
						})}
					</div>

					<div>
						{data.requisites.secondContent.map(({ description, value }) => {
							return (
								<div className={styles.requisitesWrapper} key={description}>
									<p className={styles.requisitesDescription}>{description}</p>
									<p className={styles.requisitesValue}>{value}</p>
								</div>
							)
						})}
					</div>
				</div>
			</main>
			<footer className={styles.footer}>
				<div className={styles.footerContainer}>
					<div className={styles.footerImage}>
						<Image name={isDesktop ? 'cc-logo-big' : 'cc-logo-small'} />
					</div>
					<div className={styles.footerFirst}>
						<p>© 2012—2021 ООО «Кредит.Клаб»</p>
						<a className='main-link' href='mailto:platform@credit.club'>
							platform@credit.club
						</a>
					</div>
					<div className={styles.footerSecond}>
						<p>ОГРН 1196658084743</p>
						<p>ИНН 6678105594</p>
					</div>
				</div>
			</footer>
		</div>
	)
}
